define('formkit/behavior/bind.option.to.active.section.change.behavior',['require','exports','module','marionette'],function(require, exports, module) {
  var Mn = require('marionette');

  var BindOptionToActiveSectionChangeBehavior = Mn.Behavior.extend({
    defaults: {
      // form object, uses form object passed to the view if not defined
      form: null,

      // option on the view to set
      optionName: 'active',

      // initialize with this value
      initialValue: false,

      // option value when section that is matching the model on
      // the view is an active section
      valueWhenActive: true,

      // option value when section that is matching the model on
      // the view is an not an active section
      valueWhenInactive: false,

      // when set, ignores the valueWhenActive and valueWhenInactive.
      // sets option value to the attribute value on active section
      bindValueToSectionAttribute: null
    },

    initialize: function() {
      Mn.Behavior.prototype.initialize.apply(this, arguments);

      this.form = this.getOption('form') || this.view.options.form;

      this.setViewOptionValue(this.options.initialValue);

      this
        .listenToOnce(this.view, 'before:render', function() {
          this.evaluateAndSetOption(this.form.getActiveSectionModel());
        })
        .listenTo(this.form, 'change:activeSectionModel', function(newActiveSectionModel, oldActiveSectionModel) {
          this.evaluateAndSetOption(newActiveSectionModel);
      });
    },

    evaluateAndSetOption: function(activeSectionModel) {
      if (this.getOption('bindValueToSectionAttribute') && activeSectionModel) {
        this.setViewOptionValue(activeSectionModel.get(this.getOption('bindValueToSectionAttribute')));
      }
      else {
        if(activeSectionModel == this.view.model) {
          this.setViewOptionValue(this.options.valueWhenActive);
        }
        else {
          this.setViewOptionValue(this.options.valueWhenInactive);
        }
      }
    },

    setViewOptionValue: function(value) {
      this.view[this.getOption('optionName')] = value;
    }

  });
  module.exports = BindOptionToActiveSectionChangeBehavior;
});

